import {createApp}   from "vue";
import { createStore } from 'vuex';
import apis from "@/apis";

const store =createStore({
    state: {
        clients: [],
        user_types:[],
        districts:[],
        blocks:[],
        panchyat:[],
        village:[],
        garbage_center_types:[],
      },
      actions: {
        setClients: function ({ commit }, data) {
          let payload = {};
          let promise = apis.getclientist(payload);
          promise.then((response) => {
            let clients = response.data.data;
            commit("SET_CLIENTS", clients);
          });
        },
        setGarbageCenterType: function ({ commit }, data) {
          let payload = {count:false};
          let promise = apis.centerType(payload);
          promise.then((response) => {
            let garbage_center_types = response.data.data;
            commit("SET_GARBAGECENTERTYPES", garbage_center_types);
          });
        },
        setUserTypes: function ({ commit }, client_id) {
            let payload = {"_id": client_id};
            let promise = apis.user_rolelist(payload);
            promise.then((response) => {
              let usertypes = response.data.data;
              commit("SET_USER_TYPES", usertypes);
            });
          },
        setDistricts: function ({ commit }, data) {
            let payload = {
                "client_id": data.client_id,
                "client_group_ids":data.client_group_ids,
                "count": false
            };
            let promise = apis.getStateData(payload);
            promise.then((response) => {
              let districts_response = response.data.data;
              let districts = districts_response;
              // let districts = [];
              // for (let x = 0; x < districts_response.length; x++) 
              //   {
              //       districts.push({
              //           name: districts_response[x].name,
              //           value: districts_response[x].code
              //       });
              //   }
              commit("SET_DISTRICTS", districts);
            });
          },
          setBlocks: function ({ commit }, data) {
            let payload = {
               
                "count": false
            };
            let promise = apis.getBlockData(payload);
            promise.then((response) => {
              let blocks_response = response.data.data;
              let blocks = blocks_response;
              // let blocks = [];
              // for (let x = 0; x < blocks_response.length; x++) 
              //   {
              //       blocks.push({
              //           name: blocks_response[x].name,
              //           value: blocks_response[x].code
              //       });
              //   }
              commit("SET_BLOCKS", blocks);
            });
          },
          setPanchyats: function ({ commit },  district_code,block_code) {
            let payload = {
                "district_code":district_code,
                "block_code":block_code,
                "count": false
            };
            let promise = apis.getPanchayatData(payload);
            promise.then((response) => {
              let panchyat_response = response.data.data;
              let panchyat=panchyat_response;
              //let panchyat = [];
              // for (let x = 0; x < panchyat_response.length; x++) 
              //   {
              //       panchyat.push({
              //           name: panchyat_response[x]['Local Body Code'],
              //           value: panchyat_response[x]['Local Body Name']
              //       });
              //   }
              commit("SET_PANCHYATS", panchyat);
            });
          },
          setVillages: function ({ commit }, district_code,block_code,panchayat_code) {
            let payload = {
              "count":false,
              "page_no":1,
              "limit":10000000,
              district_code:district_code,
              block_code:block_code,
              panchayat_code:panchayat_code
            };
            let promise = apis.getVillageData(payload);
            promise.then((response) => {
              let villages_response = response.data.data;
              let village=villages_response;
              commit("SET_VILLAGES", village);
            });
          }
      },
      mutations: {
        SET_CLIENTS(state, clients) {
          state.clients = clients;
        },
        SET_GARBAGECENTERTYPES(state, garbage_center_types) {
          state.garbage_center_types = garbage_center_types;
        },
        SET_USER_TYPES(state, usertypes) {
            state.user_types = usertypes;
        },
        SET_DISTRICTS(state, districts) {
            state.districts = districts;
        },
        SET_BLOCKS(state, blocks) {
            state.blocks = blocks;
        },
        SET_PANCHYATS(state, panchyat) {
          state.panchyat = panchyat;
        },
        SET_VILLAGES(state, village) {
          state.village = village;
        },
      },
      getters: {
        getClients: (state) => {
          return state.clients;
        },
        getGarbageCenterTypes: (state) => {
          return state.garbage_center_types;
        },
        getUserTypes: (state) => {
            return state.user_types;
        },
        getDistricts: (state) => {
            return state.districts;
        },
        getBlocks: (state) => {
            return state.blocks;
        },
        getPanchyats: (state) => {
          return state.panchyat;
        },
        getVillages: (state) => {
          return state.village;
        },
      },

});
export default store;
